<template>
  <div class="card">
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <div class="card-body">
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </div>
      </template>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
            <h5 class="font-size-13 teal-400 mb-1">
              {{ $t('license.object.reminder') }}
            </h5>
            <p class="font-size-10 teal-200 mb-0">
              {{ $t('dashboard.text.licenseReminder') }}
            </p>
          </div>
          <div class="col-md-4">
            <div class="float-end">
              <b-button-group class="mb-3">
                <b-button
                  @click="changeTab('fleet')"
                  :variant="isFleet ? 'primary' : 'outline-primary'"
                  ><i class="mc-fa icon-outline_car"></i> {{ $t('global.fleet') }}</b-button
                >
                <b-button
                  @click="changeTab('driver')"
                  :variant="isFleet ? 'outline-primary' : 'primary'"
                  ><i class="mc-fa icon-outline_driver"></i> {{ $t('global.driver') }}</b-button
                >
              </b-button-group>
            </div>
          </div>
        </div>
        <div class="scrollable">
          <b-row v-if="isFleet">
            <b-col cols="3" v-for="docs in fleetDoc">
              <div class="card bg-soft" :class="docs.status == 'E' ? 'bg-danger' : 'bg-warning'">
                <div class="card-body">
                  <b-row>
                    <b-col>
                      <h4>{{ docs.licensePlate }}</h4>
                    </b-col>
                    <b-col>
                      <h6>
                        <span
                          class="badge rounded font-size-14 mx-2"
                          :class="docs.status == 'E' ? 'bg-danger' : 'bg-warning'"
                          >{{
                            docs.status == 'E'
                              ? $t('license.filter.expired')
                              : $t('license.filter.willExpired')
                          }}</span
                        >
                      </h6>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <h5><i class="mc-fa icon-outline_license-general"></i> {{ docs.docType }}</h5>
                    </b-col>
                    <b-col>
                      <h5>
                        <i class="mc-fa icon-outline_calendar"></i>
                        {{ momentDateShortMonth(docs.validUntil) }}
                      </h5>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col cols="3" v-for="docs in driverDoc">
              <div class="card bg-soft" :class="docs.status == 'E' ? 'bg-danger' : 'bg-warning'">
                <div class="card-body">
                  <b-row>
                    <b-col>
                      <h4>{{ docs.fullname }}</h4>
                    </b-col>
                    <b-col>
                      <h6>
                        <span
                          class="badge rounded font-size-14 mx-2"
                          :class="docs.status == 'E' ? 'bg-danger' : 'bg-warning'"
                          >{{
                            docs.status == 'E'
                              ? $t('license.filter.expired')
                              : $t('license.filter.willExpired')
                          }}</span
                        >
                      </h6>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <h5><i class="mc-fa icon-outline_license-general"></i> {{ docs.docType }}</h5>
                    </b-col>
                    <b-col>
                      <h5>
                        <i class="mc-fa icon-outline_calendar"></i>
                        {{ momentDateShortMonth(docs.validUntil) }}
                      </h5>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <McButton
            :text="$t('dashboard.action.viewAll')"
            @click="$router.push({ name: 'List License' })"
          />
        </div>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { GET_USER_DOCS } from '@/services/api/license/userDocs'
import { GET_VEHICLE_DOCS } from '@/services/api/license/vehicleDocs'
import McButton from '@/components/McButton'
export default {
  components: {
    McButton,
  },
  mixins: [Helper],
  data() {
    return {
      isLoading: true,
      isFleet: true,
      fleetDoc: [],
      driverDoc: [],
    }
  },
  computed: {
    statusName() {
      return {
        E: this.$t('license.filter.expired'),
        AE: this.$t('license.filter.willExpired'),
      }
    },
  },
  methods: {
    async initData() {
      const fleet = await this.$apollo.query({
        query: GET_VEHICLE_DOCS,
        variables: {
          filter: {
            status: ['E', 'AE'],
          },
        },
      })
      this.fleetDoc = fleet.data.vehicleDocs.vehicleDocs
      const driver = await this.$apollo.query({
        query: GET_USER_DOCS,
        variables: {
          filter: {
            status: ['E', 'AE'],
          },
        },
      })
      this.driverDoc = driver.data.userDocs.userDoc
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
    changeTab(params) {
      this.isLoading = true
      if (params == 'fleet') {
        this.isFleet = true
      } else {
        this.isFleet = false
      }
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
  },
}
</script>
<style lang="scss">
.scrollable {
  max-height: 320px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
